import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--label-primary)";

function IconSortOldest({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg class={cssClass} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill={fill} fill-rule="evenodd" clip-rule="evenodd" d="M1.5 3.5A.5.5 0 0 1 2 3h3a.5.5 0 0 1 0 1H2a.5.5 0 0 1-.5-.5zm.5 4a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1H2zM2 12a.5.5 0 0 0 0 1h12a.5.5 0 0 0 0-1H2zm9.846-8.86a.5.5 0 0 0-.692 0l-2.5 2.4a.5.5 0 0 0 .692.72L11 4.674V9.5a.5.5 0 0 0 1 0V4.673l1.654 1.588a.5.5 0 0 0 .692-.722l-2.5-2.4z"/>
        </svg>
    );
}

export default IconSortOldest;
